/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
/* eslint-disable-file no-unused-vars */
import React, { useState, useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { InlineNotification } from 'uxd-design-system-components';
import { getResults } from '../../api/index';
import './Results.scss';
import ResultsGreeting from '../../components/ResultsGreeting/ResultsGreeting';
import ResultsMoreInfo from '../../components/ResultsMoreInfo/ResultsMoreInfo';
import ResultsItem from '../../components/ResultsItem/ResultsItem';
import Spinner from '../../components/Spinner/Spinner';
import SendResultsButton from '../../components/SendResultsButton/SendResultsButton';
import LinkBox from '../../components/LinkBox/LinkBox';
import SocialMediaButton from '../../components/SocialMediaButton/SocialMediaButton';
import DownloadButton from '../../components/DownloadButton/DownloadButton';
import {
  AnswersContext,
  LocaleContext,
  QueryContext,
  UserContext,
  PreviousPathContext,
} from '../../contexts';
import getText from '../../assets/locale/locale';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import isInViewport from '../../utils/isInViewport/isInViewport';
import ACTIONS from '../../constants/actions';
import CopyLinkButton from '../../components/CopyLinkButton/CopyLinkButton';
import ShareLinkIcon from '../../components/ShareLinkIcon/ShareLinkIcon';
import WebProspectLinkBoxImg from '../../assets/woman-at-laptop-computer.png';
import USER_PERSONA_TYPES from '../../constants/userPersonas';
import replaceSpacingWithNoBreakSpacingForFrench from '../../utils/spacingUtil/spacingUtil';
import { LOCALE_FR_CA } from '../../constants/constants';

const Results = ({
  setCurrentStep,
  sessionId,
  setErrorOccurred,
  showSendToFa,
  faInfo,
  contactName,
}) => {
  const [loading, setLoading] = useState(true);
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [sendingPdfToFa, setSendingPdfToFa] = useState(false);
  const [resultsSentToFa, setResultsSentToFa] = useState(false);
  const [results, setResults] = useState([]);
  const [moreCategories, setMoreCategories] = useState(false);
  const [moreResults, setMoreResults] = useState([]);
  const [showFindFa, setShowFindFa] = useState(false);
  const [showCaFindFa, setShowCaFindFa] = useState(false);
  const [sendResultsButtonDisabled, setSendResultsButtonDisabled] =
    useState(false);
  const [resultsToSendToDelegator, setResultsToSendToDelegator] = useState({});
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationContent, setNotificationContent] = useState({});

  const [coldContactData, setColdContactData] = useState(null);
  const [userComments, setUserComments] = useState(null);
  const [isWebProspect, setIsWebProspect] = useState(false);

  const rank = useRef(0);
  const locId = useContext(LocaleContext);
  const userPersona = useContext(UserContext);
  const { previousPath, setPreviousPath } = useContext(PreviousPathContext);
  const history = useHistory();
  const location = useLocation();
  const moreResultsCollection = useRef(null);

  const { answersDispatch } = React.useContext(AnswersContext);
  const { query, queryDispatch } = React.useContext(QueryContext);

  const showFindFaPersonaTypeArray = Array.of(
    USER_PERSONA_TYPES.WEBSITE_PROSPECT,
    USER_PERSONA_TYPES.DIRECT_URL,
    USER_PERSONA_TYPES.DIRECT_URL_CA
  );

  const getResultsHeadersString = () => {
    const resultsHeaderArray = results
      ? results.map((result) => result.recs.map((rec) => rec.title))
      : [];
    const moreResultsHeaderArray = moreResults
      ? moreResults.map((result) => result.recs.map((rec) => rec.title))
      : [];
    return resultsHeaderArray.concat(moreResultsHeaderArray).join('|');
  };

  useEffect(() => {
    let isCancelled = false;
    setCurrentStep(window.location.pathname);
    document.title = getText(locId, 'Results', 'pageTitle');

    getResults(query, locId)
      .then((res) => {
        if (!isCancelled) {
          const response =
            LOCALE_FR_CA === locId
              ? JSON.parse(
                  replaceSpacingWithNoBreakSpacingForFrench(JSON.stringify(res))
                )
              : res;
          setResultsToSendToDelegator(response);
          setResults(response.grouped_recs);
          setMoreCategories(response.more_categories);
          setMoreResults(response.more_grouped_recs);
          setIsWebProspect(userPersona === USER_PERSONA_TYPES.WEBSITE_PROSPECT);

          if (showFindFaPersonaTypeArray.includes(userPersona)) {
            setShowFindFa(true);
          }
          if (userPersona === USER_PERSONA_TYPES.DIRECT_URL_CA) {
            setShowCaFindFa(true);
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err); // eslint-disable-line no-console
        setErrorOccurred(true);
        history.push({
          pathname: getText(locId, 'AllPages', 'errorPath', 'App'),
          search: location.search,
        });
        setLoading(false);
      });

    addDataLayerTrigger('dataLayer-initialized', {
      page_type: 'resultsPage',
      locale: locId,
      environment: window.ENVIRONMENT,
      sessionId: sessionId ?? undefined,
      fa_no: faInfo.faNo ?? undefined,
      fa_entity_id: faInfo.entityIdBase64 ?? undefined,
    });
    addDataLayerTrigger('VirtualPageview', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_referrer: previousPath,
      external_referrer:
        window.document.referrer && window.document.referrer.trim() !== ''
          ? window.document.referrer
          : undefined,
      page_url: window.location.href,
    });

    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    if (resultsSentToFa && !sendingPdfToFa) {
      setSendResultsButtonDisabled(true);
    }
  }, [resultsSentToFa, sendingPdfToFa]);

  // this function needs to be in its own useEffect since it relies on the results state variable being updated in the initial useEffect
  useEffect(() => {
    initialDataLayerTriggers();
  }, [loading]);

  const goBack = () => {
    setPreviousPath(window.location.pathname);
    addDataLayerTrigger('go-back-to-hopes');
    history.push({
      pathname: getText(locId, 'AllPages', 'goalsPath', 'App'),
      search: location.search,
    });
  };

  const resetForm = () => {
    setPreviousPath(window.location.pathname);
    addDataLayerTrigger('reset-quiz', {
      'personal-age': null,
      'personal-employment-radio-selection': null,
      'personal-retirement-age': null,
      'household-marital-selection': null,
      'household-dependents-selection': null,
      concerns: null,
      hopes: null,
    });
    queryDispatch({ type: ACTIONS.RESET_FORM });
    answersDispatch({ type: ACTIONS.RESET_FORM });
    history.push({
      pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
      search: location.search,
    });
  };

  const createRank = () => {
    rank.current += 1;
    return rank.current;
  };

  const initialDataLayerTriggers = () => {
    const totalResultsNumber = results.length + moreResults.length;
    addDataLayerTrigger('initial-results-tile-viewed', {
      'total-results-number': totalResultsNumber,
    });

    addDataLayerTrigger('results-displayed', {
      'results-headers-as-string': getResultsHeadersString(),
    });

    let timeout;
    window.addEventListener(
      'scroll',
      function windowScrollHandler() {
        if (timeout) {
          window.clearTimeout(timeout);
        }
        timeout = window.setTimeout(() => {
          const resultAccordions = document.querySelectorAll(
            '.MuiAccordionSummary-root'
          );

          if (resultAccordions) {
            const bottomAccordion =
              resultAccordions[resultAccordions.length - 1];
            resultAccordions.forEach((accordion, index) => {
              if (isInViewport(accordion) && !accordion.addedToAnalytics) {
                const scoreId = accordion.id.split('-header')[0];
                addDataLayerTrigger('rec-category-view', {
                  'result-viewed': {
                    title: accordion.querySelector('p').textContent,
                    rank: index + 1,
                    scoreId,
                  },
                });
                accordion.addedToAnalytics = true;
              }
              if (
                isInViewport(bottomAccordion) &&
                !accordion.addedToAnalyticsFinal
              ) {
                addDataLayerTrigger('all-results-viewed');
                window.removeEventListener('scroll', windowScrollHandler, true);
                accordion.addedToAnalyticsFinal = true;
              }
            });
          }
          const linkBoxes = document.querySelectorAll('.linkbox-content');
          if (linkBoxes) {
            linkBoxes.forEach((linkBox, index) => {
              if (isInViewport(linkBox) && !linkBox.addedToAnalytics) {
                addDataLayerTrigger(
                  index === 0 ? 'ret-calc-scroll' : 'my-priorities-scroll'
                );
                linkBox.addedToAnalytics = true;
              }
            });
          }
        }, 100);
      },
      true
    );
  };

  const getWebProspectLinkBoxContent = () => {
    const webProspectLinkBoxContent = getText(
      locId,
      'Results',
      'gettingStartedLinkBox'
    );
    webProspectLinkBoxContent.imgSrc = WebProspectLinkBoxImg;
    return webProspectLinkBoxContent;
  };

  return (
    <main className="form-view" data-testid="form-view">
      {notificationOpen && (
        <InlineNotification
          text={notificationContent.text}
          type={notificationContent.type}
          onClose={() => setNotificationOpen(false)}
        />
      )}
      <div
        className={
          showFindFa ? 'results-top-wrapper' : 'results-top-wrapper no-findFa'
        }
      >
        {loading ? (
          <Spinner />
        ) : (
          <>
            {results.length === 0 ? (
              <div className="results-top">
                <ResultsMoreInfo goBack={goBack} resetForm={resetForm} />
              </div>
            ) : (
              <ResultsGreeting
                downloadingPdf={downloadingPdf}
                setDownloadingPdf={setDownloadingPdf}
                showFindFa={showFindFa}
                showCaFindFa={showCaFindFa}
                showSendToFa={showSendToFa}
                sendingPdfToFa={sendingPdfToFa}
                setSendingPdfToFa={setSendingPdfToFa}
                setResultsSentToFa={setResultsSentToFa}
                sendResultsButtonDisabled={sendResultsButtonDisabled}
                resultsToSendToDelegator={resultsToSendToDelegator}
                setNotificationContent={setNotificationContent}
                setNotificationOpen={setNotificationOpen}
                query={query}
                sessionId={sessionId}
                coldContactData={coldContactData}
                setColdContactData={setColdContactData}
                faInfo={faInfo}
                contactName={contactName}
                userComments={userComments}
                setUserComments={setUserComments}
                isWebProspect={isWebProspect}
              />
            )}
          </>
        )}
      </div>

      {results.length !== 0 ? (
        <div className="all-results" data-testid="all-results">
          <div className="results">
            <div>
              <h2>{getText(locId, 'Results', 'topResultsHeading')}</h2>
              <div className="top-results">
                {results.map((resultGroup, index) => (
                  <ResultsItem
                    index={`main-res-${index + 1}`}
                    startExpanded={index === 0}
                    resultGroup={resultGroup}
                    key={resultGroup.reason}
                    createRank={createRank}
                  />
                ))}
              </div>
            </div>
          </div>

          <div
            className={
              showFindFa
                ? 'linkbox-container three-cards'
                : 'linkbox-container two-cards'
            }
          >
            <LinkBox
              linkBoxContent={getText(locId, 'Results', 'retireCalcLinkBox')}
              dataLayerName="ret-calc-click"
              showFindFa={showFindFa}
            />
            {isWebProspect ? (
              <LinkBox
                linkBoxContent={getWebProspectLinkBoxContent()}
                dataLayerName="get-started-click"
                showFindFa={showFindFa}
              />
            ) : (
              <LinkBox
                linkBoxContent={getText(
                  locId,
                  'Results',
                  'myPrioritiesLinkBox'
                )}
                dataLayerName="my-priorities-click"
                showFindFa={showFindFa}
              />
            )}
            {showFindFa && !showCaFindFa ? (
              <LinkBox
                linkBoxContent={getText(locId, 'Results', 'eJMatchLinkBox')}
                dataLayerName="ej-match-click"
                showFindFa={showFindFa}
              />
            ) : null}
          </div>

          {moreCategories && (
            <div className="more-results-container">
              <div className="more-results">
                <h2>{getText(locId, 'Results', 'moreResultsHeading')}</h2>
                <div ref={moreResultsCollection}>
                  {moreResults.map((resultGroup, index) => (
                    <ResultsItem
                      index={`more-res-${index + 1}`}
                      startExpanded={false}
                      resultGroup={resultGroup}
                      key={resultGroup.reason}
                      createRank={createRank}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="cta_container">
            <div className="shareQuiz_container">
              <h2>
                {getText(locId, 'Results', 'shareQuizHeading', 'shareQuizCta')}
              </h2>
              <p>
                {getText(locId, 'Results', 'shareQuizMessage', 'shareQuizCta')}
              </p>
              <div className="shareQuizButton_container">
                <div className="copyLink_action_btn">
                  <CopyLinkButton />
                </div>
                <div className="action_btns_container">
                  <div className="shareQuiz_action_btn">
                    <p>
                      {getText(locId, 'Results', 'shareLink', 'shareQuizCta')}
                    </p>
                  </div>
                  <SocialMediaButton
                    icon="/public/images/linkedin-icon.png"
                    socialMediaLink={getText(
                      locId,
                      'Results',
                      'linkedInUrl',
                      'shareQuizCta'
                    )}
                    title={getText(
                      locId,
                      'Results',
                      'socialMediaTitle',
                      'shareQuizCta'
                    ).replace('%APP_NAME%', 'LinkedIn')}
                  />
                  <SocialMediaButton
                    icon="/public/images/facebook-icon.png"
                    socialMediaLink={getText(
                      locId,
                      'Results',
                      'faceBookUrl',
                      'shareQuizCta'
                    )}
                    title={getText(
                      locId,
                      'Results',
                      'socialMediaTitle',
                      'shareQuizCta'
                    ).replace('%APP_NAME%', 'Facebook')}
                  />
                  <ShareLinkIcon />
                </div>
              </div>
            </div>
          </div>

          <div className="final-actions-wrapper">
            <div className="results">
              <div className="final-actions bottom-buttons">
                {!isWebProspect ? (
                  <DownloadButton
                    resultsToSendToDelegator={resultsToSendToDelegator}
                    downloadingPdf={downloadingPdf}
                    setDownloadingPdf={setDownloadingPdf}
                    setNotificationContent={setNotificationContent}
                    setNotificationOpen={setNotificationOpen}
                    coldContactData={coldContactData}
                    userComments={userComments}
                  />
                ) : null}
                {!isWebProspect && showFindFa ? (
                  <span>
                    <a
                      href={getText(locId, 'Results', 'findFaLink')}
                      target="_blank"
                      rel="noopener noreferrer"
                      tabIndex="-1"
                      onClick={() => addDataLayerTrigger('results-find-button')}
                    >
                      <div className="find-fa">
                        <button
                          type="button"
                          id="results-connect-with-fa"
                          className="button button-primary find-fa-button"
                          data-testid="results-connect-with-fa"
                        >
                          {getText(locId, 'Results', 'findFaButton')}
                        </button>
                      </div>
                    </a>
                  </span>
                ) : null}
                {showSendToFa ? (
                  <SendResultsButton
                    sendingPdfToFa={sendingPdfToFa}
                    setSendingPdfToFa={setSendingPdfToFa}
                    setResultsSentToFa={setResultsSentToFa}
                    sendResultsButtonDisabled={sendResultsButtonDisabled}
                    resultsToSendToDelegator={resultsToSendToDelegator}
                    setNotificationContent={setNotificationContent}
                    setNotificationOpen={setNotificationOpen}
                    query={query}
                    sessionId={sessionId}
                    coldContactData={coldContactData}
                    setColdContactData={setColdContactData}
                    faInfo={faInfo}
                    contactName={contactName}
                    setUserComments={setUserComments}
                    userComments={userComments}
                  />
                ) : null}
              </div>

              <div className="final-nav">
                <button
                  id="results-back-button"
                  data-testid="results-back-button"
                  type="button"
                  className="button button-secondary"
                  onClick={goBack}
                >
                  {getText(locId, 'AllPages', 'backButton')}
                </button>
                <button
                  type="button"
                  id="results-start-over-button"
                  data-testid="results-start-over-button"
                  className="button button-primary"
                  onClick={resetForm}
                >
                  {getText(locId, 'Results', 'startOverButton')}
                </button>
              </div>

              <p className="backend-disclaimer">
                {getText(locId, 'Results', 'resultsDisclaimer')}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </main>
  );
};

Results.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
  sessionId: PropTypes.string.isRequired,
  setErrorOccurred: PropTypes.func.isRequired,
  showSendToFa: PropTypes.bool,
  faInfo: PropTypes.objectOf(PropTypes.string),
  contactName: PropTypes.objectOf(PropTypes.string),
};

Results.defaultProps = {
  showSendToFa: false,
  faInfo: {
    faFirstName: null,
    faLastName: null,
    branchNo: null,
    faNo: null,
    faPhoto: null,
  },
  contactName: {},
};

export default Results;
